import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./components/Elements/Button";
import { LandingPage } from "./routes/RoutesPath";
import ErrorHandle from "./assets/images/MainError.svg";
import { useSelector } from "react-redux";

const PageNotFound = () => {
  const navigate = useNavigate();
  const websiteColor = useSelector((state) => state?.onLoadData?.color);

  useEffect(() => {}, []);

  const handleHomeClick = () => {
    navigate(LandingPage);
  };

  return (
    <div className="w-full h-screen py-8 flex flex-col items-center justify-center">
      <img
        className="w-full max-w-[614px] h-auto"
        src={ErrorHandle}
        alt="error image"
      />
      <span
        className="font-medium text-lg md:text-p6 text-center"
        style={{ color: websiteColor }}
      >
        Page Not Found!
      </span>
      <div className="mt-2 mb-2">
        <Button
          onClick={handleHomeClick}
          className="w-full md:w-max px-6 py-2 md:py-4 text-white text-md font-semibold"
          type={"primary"}
        >
          <span>Go to Home Page</span>
        </Button>
      </div>
    </div>
  );
};

export default PageNotFound;
